// The Action Center's own words (lane B1; DC-45, DS §1.4): the sort and filter words the shared modules do not carry.
// The priority sort reads his Priority (HM-2: "sort and filter by: Priority · …"; glossary §2, where DC-45 says what
// it means: an action's priority is its SLA tier). The phone's one filter control reads his Filters (glossary §14).
// The tabs, the kind icons, the tier groups, Overdue, Sort and Clear come from src/mc. The nine kind chips read his
// kind words in sentence case (F-77), the BRD's "reqs" as his Requisitions (G §21). labels.test.mjs holds these tables
// to the same quote, provenance and pending rules.

import { defineLabels, template } from "@/mc/labels";

const DC45 = "Priority is the SLA tier; groups *Breach — dashboard risk · Near-breach · Reminder · Due*; sort *Priority · Due · Requisition*; kind chips in his nine words.";
const HM2 = "\"Add the ability to sort and filter by: Priority · Days Open · Brand · Function · Recruiting Phase · Location · Recruiter · Status\"";
const KINDS = "Prioritized actions across reqs, candidates, scheduling, packets, scorecards, panels, approvals, offers and closeout.";
const REQS = "| Requisitions | **Requisitions** | Email; BRD \"reqs\" |";
const FILTERS = "| Filters | \"Support date, recruiter, coordinator, HRBP, HM, function, department, brand, job family, area of interest, level, location, strategy, new/replacement, status, phase, health, days open, time in stage, source, internal/external, offer status, standardized reasons, saved views, grouping, sorting, security-trimmed drill-down and exports.\" |";

export const ACTION_CENTER_LABELS = /* @__PURE__ */ defineLabels({
  /** The priority sort: the SLA tier, then due, then requisition. */
  priority: { text: "Priority" },
  /** The requisition sort, and the name of the requisition filter chip. */
  requisition: { text: "Requisition" },
  /** The fifth tier group, for an item a rule holds back. */
  blocked: { text: "Blocked" },
  /** At ≤ 768 px: the one button that opens the filter sheet, and the sheet's title. */
  filters: { text: "Filters" },
});

/** The nine kind chips, in his order (G §2): his kind words in sentence case, the BRD's reqs as his Requisitions. */
export const ACTION_KIND_CHIP_LABELS = /* @__PURE__ */ defineLabels({
  reqs: { text: "Requisitions" },
  candidates: { text: "Candidates" },
  scheduling: { text: "Scheduling" },
  packets: { text: "Packets" },
  scorecards: { text: "Scorecards" },
  panels: { text: "Panels" },
  approvals: { text: "Approvals" },
  offers: { text: "Offers" },
  closeout: { text: "Closeout" },
});

// Lane B13 (F-159, DS DC-238): a meeting invitation is a row the attendee answers in place, and the organizer's and the
// Recruiter's tracking row counts the answers. Accept and Decline are the design system's verbs; Tentative is his third
// answer on the same row.
const RESPOND =
  "Each attendee of a scheduled meeting gets the Action Center row **Respond: {meeting} · {requisition id} · {when}** with **Accept** · **Tentative** · **Decline** on it; the answer closes it, a reschedule opens it again.";
const TRACK = "**{meeting} scheduled · responses {n} of {m}**, which becomes **Reschedule — {name} declined**";
const RESCHEDULE_ROW = "the Coordinator's Workbench row and Action Center row **Reschedule request · {meeting} · {requisition id}**";

export const RESPOND_LABELS = /* @__PURE__ */ defineLabels({
  tentative: { text: "Tentative" },
});

export const RESPOND_TEMPLATES = {
  /** The tracking row's count after the server's title. */
  responses: /* @__PURE__ */ template({ text: "responses {n} of {m}" }),
};

/** The scheduling rows whose title is one name, never his "verb — object" (F-159, F-162; DC-238, DC-241): the row
 * draws the server's title whole, as these templates write it (C6, C11). */
export const SCHEDULING_ROW_TEMPLATES = {
  scheduled: /* @__PURE__ */ template({ text: "{meeting} scheduled" }),
  declined: /* @__PURE__ */ template({ text: "Reschedule — {name} declined" }),
  rescheduleRequest: /* @__PURE__ */ template({ text: "Reschedule request · {meeting} · {requisition id}" }),
};
